/**
 * ErrorListItemMessage  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

export interface IErrorListItemMessageProps {}

export const ErrorListItemMessage = React.memo<IErrorListItemMessageProps>((props) => {
	const baseClass = BEM("edt-error-list", "item-message");

	return <div className={baseClass.toClassName()} {...props} />;
});

ErrorListItemMessage.displayName = "ErrorListItemMessage";
